import dayjs from "dayjs";
import { PaymentComponentProps } from "./Item";
import { RightOutlined } from "@ant-design/icons";
import { Avatar, Col, Row } from "antd";
import { useGetIcon } from "../../hooks/useGetIcon";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";

export const RegularPayment = ({ values }: PaymentComponentProps) => {
  const { getIcon } = useGetIcon();

  return (
    <>
      <Col span={4}>
        <Row className="align-center avatar">
          <Avatar
            icon={getIcon("RegularPayment")}
            size={40}
            className="option d-flex justify-center"
          />
        </Row>
      </Col>
      <Col span={12}>
        <Row className="d-block h-100 align-content-center item-title">
          <p className="my-0 text-md w-500">Regular Payment</p>
          <p className="my-0 text-md title elipsis">
            Due {dayjs(values.dueDate).format("MMM D")}
          </p>
        </Row>
      </Col>

      <Col span={6}>
        <Row className="d-block h-100 text-align-end item-amount">
          <p className="my-0 text-md w-500 text-no-wrap">
            {getFormattedCurrency(values.amount)}
          </p>
          <p className="my-0 text-md title">
            {dayjs(values.date).format("MMM D")}
          </p>
        </Row>
      </Col>

      <Col span={1}>
        <Row className="h-100">
          <RightOutlined className="text-sm title" />
        </Row>
      </Col>
    </>
  );
};
